import { Flex } from 'antd';

import { getClassName } from '../_utils';

import './Toolbar.scss';

export function Toolbar(props: {
  left?: React.ReactNode;
  right?: React.ReactNode;
}) {
  return (
    <Flex
      className={getClassName('toolbar')}
      justify="space-between"
      align="center"
    >
      <Flex align="center" gap={10}>
        {props.left ?? ' '}
      </Flex>
      <Flex align="center" gap={10}>
        {props.right ?? ' '}
      </Flex>
    </Flex>
  );
}
